angular.module('filters').filter('taxRate', function() {
  return function(rate) {
    if (rate.id) {
      return `${rate.name} (${rate.percent}%)`;
    } else {
      return '';
    }
  };
});
